<template>
  <div class="platform-box" ref="myElementRef">
    <el-alert
      class="tip-bar"
      type="info"
      :closable="false"
      :title="t('auditLog.tip')"
    />
    <div ref="searchBox">
      <hc-search :data="searchData" @serch="getSearch" />
    </div>

    <hc-table
      :tableData="state.tableData"
      :column="state.tableHeader"
      :offsetHeight="state.offsetHeight"
      :maxPage="maxPage"
      @pageChange="pageChange"
      @limitChange="limitChange"
    >
      <template #status="{ row }">
        <el-tag :type="row.status >= 500 ? 'danger' : row.status >= 400 ? 'warning' : 'info'" size="small">
          {{ row.status }}
        </el-tag>
      </template>
      <template #real_name="{ row }">
        {{ row.real_name || row.username || '—' }}
      </template>
      <template #created_at="{ row }">{{ formatDisplayDateTime(row.created_at) || '—' }}</template>
    </hc-table>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, nextTick } from 'vue'
import hcSearch from '@/components/hc-search/index.vue'
import hcTable from '@/components/hc-table/index.vue'
import { apiAccessLogListApi } from '@/api/system/operationLog'
import { formatDisplayDateTime } from '@/utils/dateTime.js'
import { usePageI18n, t } from '@/composables/usePageI18n.js'
import { ElMessage } from 'element-plus'

const myElementRef = ref()
const searchBox = ref()
const maxPage = ref(0)
const page = ref(1)
const limit = ref(20)

const searchData = reactive([
  { label: t('field.keywords'), type: 'input', value: '', field: 'keywords', placeholder: t('auditLog.keywordPlaceholder') },
])

const state = reactive({
  offsetHeight: 0,
  tableData: [],
  tableHeader: [],
  column: [
    { type: 'index', label: t('table.index'), width: 70, show: true },
    { prop: 'method', label: t('auditLog.method'), width: 80, show: true },
    { prop: 'path', label: t('auditLog.path'), show: true },
    { prop: 'status', label: t('auditLog.httpStatus'), width: 100, show: true },
    { prop: 'error_msg', label: t('auditLog.errorMsg'), width: 180, show: true },
    { prop: 'real_name', label: t('auditLog.operator'), width: 120, show: true },
    { prop: 'role_id', label: t('field.role'), width: 80, show: true },
    { prop: 'created_at', label: t('auditLog.operatedAt'), width: 155, show: true },
  ],
})

const applyLabels = () => {
  searchData[0].label = t('field.keywords')
  searchData[0].placeholder = t('auditLog.keywordPlaceholder')
  state.column[0].label = t('table.index')
  state.column[1].label = t('auditLog.method')
  state.column[2].label = t('auditLog.path')
  state.column[3].label = t('auditLog.httpStatus')
  state.column[4].label = t('auditLog.errorMsg')
  state.column[5].label = t('auditLog.operator')
  state.column[6].label = t('field.role')
  state.column[7].label = t('auditLog.operatedAt')
  tableHeaderFn()
}

const tableHeaderFn = () => {
  state.tableHeader = state.column.filter((v) => v.show)
}

const offHeighths = () => {
  if (myElementRef.value) {
    state.offsetHeight = myElementRef.value.offsetHeight - 120 - (searchBox.value?.offsetHeight || 0)
  }
}

const getSearch = (params) => {
  apiAccessLogListApi({
    page: page.value,
    limit: limit.value,
    keywords: params?.keywords ?? searchData[0].value ?? '',
  }).then((res) => {
    if (res.code === 200) {
      state.tableData = res.data || []
      maxPage.value = res.maxPage || 0
    } else {
      ElMessage.error(res.msg || t('auditLog.loadFailed'))
    }
  })
}

const pageChange = (p) => {
  page.value = p
  getSearch()
}

const limitChange = (l) => {
  limit.value = l
  page.value = 1
  getSearch()
}

usePageI18n(applyLabels)

onMounted(() => {
  applyLabels()
  nextTick(() => {
    offHeighths()
    getSearch()
  })
})
</script>

<style lang="scss" scoped>
.platform-box {
  flex: 1;
  overflow: auto;
  background: #fff;
  border-radius: 6px;
  padding: 10px;
  margin-right: 10px;
}
.tip-bar {
  margin-bottom: 12px;
}
</style>
